import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LoadingController, NavController, NavParams, ViewController } from 'ionic-angular';
import { OrganizationCheckRegister, RodeoInfo } from '../../../../model/organizationCheckRegister';
import { OrganizationCheckRegisterService } from '../../../../services/organization-check-service';
import { AlertMessager } from '../../../../lib/alertMessager';

@Component({
  selector: 'add-check-register',
  templateUrl: 'add-check-register.html'
})
export class AddCheckRegisterComponent implements OnInit {

  text: string;
  formSubmitted: boolean = false;
  newCheckRegister: FormGroup;
  rodeoInfo: RodeoInfo;
  formCheck: OrganizationCheckRegister;
  submitAttempt: boolean = false;
  editing: boolean = false

  constructor(
    private navParams: NavParams,
    public loadingCtrl: LoadingController,
    private formBuilder: FormBuilder,
    private nav: NavController,
    private viewController: ViewController,
    private alertMessager: AlertMessager,
    private organizationCheckService: OrganizationCheckRegisterService,
  ) {
    this.rodeoInfo = this.navParams.get('rodeoInfo');
    this.formCheck = this.navParams.get('formCheck');

    if (!this.formCheck) {
      this.formCheck = new OrganizationCheckRegister();
    } else {
      this.editing = true;
    }
  }

  ngOnInit() {
    this.createForm();
  }

  showLoading(text: string) {
    let loader = this.loadingCtrl.create({ content: text });
    loader.present();
    return loader;
  }

  dismissLoading(loader: any) {
    if (loader) {
      loader.dismiss();
    }
  }

  createForm() {
    this.newCheckRegister = this.formBuilder.group({
      name: [this.formCheck.name, Validators.required],
      streetAddress: [this.formCheck.streetAddress, Validators.required],
      city: [this.formCheck.city, Validators.required],
      state: [this.formCheck.state, Validators.required],
      zipcode: [this.formCheck.zipcode, Validators.required],
      amount: [this.formCheck.amount, [Validators.required, Validators.minLength(1), Validators.pattern(/^[0-9]+(\.[0-9]{1,2})?$/)]],
      checkNumber: [this.formCheck.checkNumber, Validators.required],
      memo: [this.formCheck.memo],
      voided: [this.formCheck.voided]
    });
  }

  async save() {
    this.submitAttempt = true;

    if (!this.newCheckRegister.valid) {
      return;
    }

    let loader = this.showLoading(this.editing ? "Updating..." : "Creating...");

    const rodeoId = this.rodeoInfo ? this.rodeoInfo.rodeoId : null;
    const organizationId = this.rodeoInfo ? this.rodeoInfo.organizationId : null;

    let formData: OrganizationCheckRegister = {
      ...this.newCheckRegister.value,
      id: this.formCheck.id,
      rodeoId: rodeoId,
      organizationId: organizationId,
      datePrinted: new Date().toLocaleString(),
    };

    if (!this.editing) {
      formData.voided = false;

      try {
        var response = await this.organizationCheckService.CreateOrganizationCheckRegisters([formData]);

        if (response && response.length > 0)
          formData = response[0];

        this.viewController.dismiss(formData);
      } catch (error) {
        this.alertMessager.showError('Error', error.message);
      } finally {
        this.dismissLoading(loader);
      }
    }
    else {
      try {
        var response = await this.organizationCheckService.updateCheckRegisters([formData]);

        if (response && response.length > 0)
          formData = response[0];

        this.viewController.dismiss(formData);
      } catch (error) {
        this.alertMessager.showError('Error', error.message);
      } finally {
        this.dismissLoading(loader);
      }
    }
  }

  void() {
    this.newCheckRegister.value.voided = !this.newCheckRegister.value.voided;

    this.save();
  }

  cancel() {
    this.nav.pop();
  }
}



// WEBPACK FOOTER //
// ./src/pages/print-checks/check-register/add-check-register/add-check-register.ts